import { put } from "../../common/api/apiShared";
import { ChangeEntityTemplateActiveStatusDialogProps } from "./ChangeEntityTemplateActiveStatusDialog.tsx";
import { useDotLegalSnackbar } from "@dotlegal/dotlegal-ui-components";
import { createElement } from "react";
import { Trans } from "react-i18next";
import { useDotLegalMutation } from "@common/hooks/dotLegalReactQuery";
import { getEntityTemplateTranslationKeys } from "../EntityTemplate.types.ts";

export function useChangeEntityTemplateActiveStatusDialog(props: ChangeEntityTemplateActiveStatusDialogProps) {
    const snackbar = useDotLegalSnackbar();
    const toggleActiveStatusMutation = useDotLegalMutation(toggleEntityTemplateStatusApi);
    const onToggleActiveStatus = () => {
        toggleActiveStatusMutation.mutateAsync(undefined, {
            onSuccess: () => {
                if (props.entityTemplate.active) {
                    snackbar.show(createElement(Trans, { i18nKey: "wasDeactivated", values: { name: props.entityTemplate!.name } }));
                } else {
                    snackbar.show(createElement(Trans, { i18nKey: "wasActivated", values: { name: props.entityTemplate!.name } }));
                }
                props.onToggledActiveStatus();
            },
        });
    };

    return {
        inProgress: false,
        onToggleActiveStatus,
        infoTranslationKey: getInfoTranslationKey(),
    };

    function getInfoTranslationKey() {
        if (!props.entityTemplate.active) {
            return "activeEntityTemplateInfo";
        }

        return getEntityTemplateTranslationKeys(props.templateEntityType).deactivateInfo;
    }

    function toggleEntityTemplateStatusApi() {
        return put(`/entity-templates/${props.entityTemplate.id}/toggle-active-status`, !props.entityTemplate.active);
    }
}
